import { CatButton } from '@blocks-react/components/Button';
import { AddToCartBtnProps } from '../types';

export const AddToCartBtn = ({ children, onClick }: AddToCartBtnProps) => {
  return (
    <CatButton variant="primary" size="sm" fullWidth onClick={onClick}>
      {children}
    </CatButton>
  );
};
